import React from 'react'
import "./Order.css"
import moment from "moment"
import ProductItem from "./ProductItem"
import CurrencyFormat from 'react-currency-format'


function Order({order}) {
    return (
    <div className='order'>
        <h2>Order</h2>
        <p>
            
            {moment.unix(order.data.created).format('MMMM Do YYYY, h:mm A')}
        </p>
        <p className='order-id'>
            <small>
                {order.id}
            </small>
        </p>

        {order.data.basket?.map(item => <ProductItem id={item.id} image={item.image} title={item.title} price={item.price} rating={item.rating} hideButton={true}/>)}
         {       <CurrencyFormat 
                renderText={(value)=>(
                            <h3 className='order-total'>
                                Order Total ({order.data.basket.length} items): <strong>${order.data.total.toFixed(2)}</strong>
                            </h3>
                )}
            
            decimalScale={2}
            thousandSeparator={true}
            displayType={"text"}
            prefix={"$"}
            
        />
        
        
        }

    </div>
  )
}

export default Order